import React from 'react';
import { ExternalLinks } from 'shared/enums/external-links.enum';
import commonStyles from 'shared/components/CurrencySelect/CurrencySelect.module.scss';
import { useCurrencyContext } from 'app/contexts/Currency/CurrencyContext';
import classnames from 'classnames';

export const CurrencyOnboardingHelp: React.FC<any> = () => {
  const currencyContext = useCurrencyContext();
  return (
    <div className={classnames(commonStyles.currencyHelpText, currencyContext?.active ? '' : commonStyles.disabled)}>
      <div>
        Set a new processing currency to be displayed in your account <br /> instead of the provider's default currency.
      </div>
      <br />
      <div className={commonStyles.note}>Note:</div>
      <ol className={commonStyles.noteItems}>
        <li>
          The currency change applies to all users with access to this <br />
          account.
        </li>
        <li>It will be reflected on select platform pages.</li>
        <li>
          The exchange rate is fixed for the entire month and is <br /> determined based on the last business day of the
          previous <br />
          month.
        </li>
        <br />
      </ol>
      <div>
        <a href={ExternalLinks.CurrenciesDocumentation} target="_blank" className={commonStyles.navigateText}>
          Learn more
        </a>
      </div>
    </div>
  );
};
